export class Subsidiary {
    public readonly id!: string;
    public readonly name!: string;
}
